import type { RouteRecordRaw } from 'vue-router'
import { legacyTenantRedirect, maybeRouteName } from './tenantScoped'

const createRequirementChildren = (withNames: boolean): RouteRecordRaw[] => [
  {
    path: '',
    ...maybeRouteName(withNames, 'requirements'),
    component: () => import('@/views/requirement/RequirementList.vue'),
    meta: { permission: 'requirement:record:view' }
  },
  {
    path: ':id',
    ...maybeRouteName(withNames, 'requirement-detail'),
    component: () => import('@/views/requirement/RequirementDetail.vue'),
    meta: { permission: 'requirement:record:view' }
  }
]

const createRequirementRoute = (path: string, withNames: boolean): RouteRecordRaw => ({
  path,
  component: () => import('@/views/requirement/RequirementLayout.vue'),
  ...(withNames ? {} : { beforeEnter: legacyTenantRedirect }),
  meta: {
    permission: 'requirement:record:view',
    ...(!withNames ? { legacyTenantRedirect: true } : {}),
  },
  children: createRequirementChildren(withNames)
})

const requirementRoutes: RouteRecordRaw[] = [
  createRequirementRoute('t/:tenantCode/requirements', true),
  createRequirementRoute('requirements', false),
]

export default requirementRoutes
